<template>
    <div>
        <Head title="Dashboard"/>
        <h1 class="mb-8 text-3xl font-bold">Dashboard</h1>

        <div class="flex w-full">
            <div class="p-5  max-w-xs w-full bg-white rounded-md shadow overflow-hidden mr-5">
                <h1 class="mt-2 text-xl text-center font-bold">Users</h1>
                <p class="flex justify-center">
                    <span class="mt-2 text-5xl text-center font-bold">{{ stats.users_count }}</span>
                </p>
            </div>
            <div class="p-5 max-w-xs w-full bg-white rounded-md shadow overflow-hidden mr-5">
                <h1 class="mt-2 text-xl text-center font-bold">Brands</h1>
                <p class="flex justify-center">
                    <span class="mt-2 text-5xl text-center font-bold">{{ stats.brands_count }}</span>
                </p>
            </div>
            <div class="p-5  max-w-xs w-full bg-white rounded-md shadow overflow-hidden mr-5">
                <h1 class="mt-2 text-xl text-center font-bold">Customers</h1>
                <p class="flex justify-center">
                    <span class="mt-2 text-5xl text-center font-bold">{{ stats.customers_count }}</span>
                </p>
            </div>
            <div class="p-5  max-w-xs w-full bg-white rounded-md shadow overflow-hidden mr-5">
                <h1 class="mt-2 text-xl text-center font-bold">Offers</h1>
                <p class="flex justify-center">
                    <span class="mt-2 text-5xl text-center font-bold">{{ stats.offers_count }}</span>
                </p>
            </div>
            <div class="p-5  max-w-xs w-full bg-white rounded-md shadow overflow-hidden mr-5">
                <h1 class="mt-2 text-xl text-center font-bold">Orders</h1>
                <p class="flex justify-center">
                    <span class="mt-2 text-5xl text-center font-bold">{{ stats.orders_count }}</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import {Head} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'

export default {
    components: {
        Head,
    },
    layout: Layout,
    props: {
        stats: Object,
    },
}
</script>
